import React, { useState } from "react";
import Button from "./Button";

const Tabs = ({ tabs }) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="w-full">
            <div className="flex space-x-2 mb-4">
                {tabs.map((tab, index) => (
                    <Button
                        key={index}
                        onClick={() => setActiveTab(index)}
                        variant={activeTab === index ? "tab-active" : "tab"}
                    >
                        {tab.label}
                    </Button>
                ))}
            </div>
            <div className="w-full">{tabs[activeTab].content}</div>
        </div>
    );
};

export default Tabs;
